import { Card as CardAntd, Table as TableAntd } from 'antd';
import styled, { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  .hidden {
    display: none;
  }

  .margin-sides {
    margin: 0 8px
  }

  .height-85 {
    height: '85vh';
    min-height: '85vh';
  }

  .padding-left-37 {
    padding-left: 37px;
  }

  .ant-tabs-nav {
    padding-left:40px;
    padding-right:40px;
    margin-bottom: 10px !important;
  }
`;

export const Card = styled(CardAntd)`
  .ant-card-body {
    padding: 12px 24px;
  }
`;

export const Table = styled(TableAntd)`
  .ant-table {
    border-right: 1px solid #dfdfdf;
    border-bottom: 1px solid #dfdfdf;
  }

  .ant-table,
  .ant-table-thead > tr > th {
    color: #676a6c;
  }

  .ant-table-thead > tr > th {
    font-weight: 700;
    font-size: 12px;
    height: 44px;
    background: #f5f5f6;
    border: 1px solid #dfdfdf;
  }

  table tr > td {
    padding: 0px 16px;
    font-size: 12px;
    border: 1px solid #e6e6e6;
    background: #ffffff;
    height: 56px;
  }
`;
